const FilterModule = {
    namespaced: true,
    state: () => ({
        filter: {},
    }),
    getters: {
        getFilter (state) {
            return state.filter
        },
    },
    mutations: {
        setFilter (state, payload) {
            state.filter = payload
        },
    },
    actions: {
        setFilter (context, payload) {
            context.commit('setFilter', payload);
        },
    },
}
export default FilterModule;
